import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.ADAS_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.ADAS_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.ADAS_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.ADAS_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.ADAS_FILTER_BY, filterBy)
  },
  [types.INIT_ADAS](state) {
    state.highlightSave = false
    state.adas = JSON.parse(JSON.stringify(state.default))
  },
  [types.INIT_ADASINSPECTION](state) {
    state.highlightSave = false
    state.adasInspection = JSON.parse(JSON.stringify(state.defaultInspection))
  },
  [types.SET_ADAS](state, data) {
    state.adas = data
  },
  [types.SET_ADASS](state, data) {
    state.adass = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adass = data
      }
    }
  },
  [types.UPDATE_ADAS](state, data) {
    if (state.adas !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.adas.firm = parseInt(data.value)
          state.adas.vehicle.firm = parseInt(data.value)
          break
        case 'adas':
          state.adas.adas = parseInt(data.value)
          break
        case 'adasType':
          state.adas.adasType = parseInt(data.value)
          break
        case 'insurance':
          state.adas.insurance = parseInt(data.value)
          break
        case 'ronumber':
          state.adas.ronumber = data.value
          break
        case 'vehicleYear':
          state.adas.vehicle.year = data.value
          break
        case 'vehicleMake':
          state.adas.vehicle.make = data.value
          break
        case 'vehicleModel':
          state.adas.vehicle.model = data.value
          break
        case 'vehicleVin':
          state.adas.vehicle.vin = data.value
          break
        case 'createdBy':
          state.adas.createdBy = data.value
          break
        case 'notes':
          state.adas.notes = data.value
          break
        case 'status':
          state.adas.status = parseInt(data.value)
          break
      }
    }
  },
  [types.SET_ADASINSPECTIONS](state, data) {
    state.adasInspections = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasInspections = data
      }
    }
  },
  [types.SET_ADASINSPECTION](state, data) {
    state.adasInspection = data
  },
  [types.UPDATE_ADASINSPECTION](state, data) {
    // console.log('Update Inspection', { data: data, inspection: state.adasInspection })
    if (state.adasInspection !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.adasInspection.firm = parseInt(data.value)
          break
        case 'adas':
          state.adasInspection.adas = parseInt(data.value)
          break
        case 'inspectionType':
          state.adasInspection.adasInspectionType = parseInt(data.value)
          break
        case 'inspector':
          state.adasInspection.inspector = parseInt(data.value)
          break
        case 'insurance':
          state.adasInspection.insurance = parseInt(data.value)
          state.adasInspection.insuranceName = data.extra
          break
        case 'ronumber':
          state.adasInspection.ronumber = data.value
          break
        case 'notes':
          state.adasInspection.notes = data.value
          break
        case 'status':
          state.adasInspection.status = data.value
          break
      }
    }
    let foundInspection = state.adasInspections.find((x) => parseInt(x.adasInspection) === parseInt(state.adasInspection.adasInspection))
    if (foundInspection !== undefined && foundInspection !== null) {
      foundInspection.ronumber = state.adasInspection.ronumber
      foundInspection.insurance = state.adasInspection.insuranceName
      foundInspection.inspector = state.adasInspection.inspectorName
    }
  },
  [types.UPDATE_ADAS_INSPECTION_RECORD](state, data) {
    let foundInspection = state.adasInspections.find((x) => parseInt(x.adasInspection) === parseInt(data.adasInspection))
    if (foundInspection !== undefined && foundInspection !== null) {
      foundInspection.ronumber = data.ronumber
      foundInspection.insurance = data.insuranceName
      foundInspection.inspector = data.inspectorName
    }
  },
  [types.SET_ADAS_STATUS](state, data) {
    state.adas.status = data.status
  },
  [types.SET_ADAS_INSPECTION_STATUS](state, data) {
    state.adasInspection.status = data.status
    let foundInspection = state.adasInspections.find((x) => parseInt(x.adasInspection) === parseInt(data.adasInspection))
    if (foundInspection !== undefined && foundInspection !== null) {
      if (parseInt(data.status) === 2) {
        foundInspection.status = 2
        foundInspection.statusName = 'Complete'
        let foundInspections = state.adasInspections.filter((x) => parseInt(x.adas) === parseInt(foundInspection.adas))
        if (foundInspections !== undefined && foundInspections !== null) {
          let isComplete = true
          foundInspections.forEach((element) => {
            if (element.statusName !== 'Complete') {
              isComplete = false
            }
          })
          if (isComplete) {
            let foundAdas = state.adass.items.find((x) => parseInt(x.adas) === parseInt(foundInspection.adas))
            if (foundAdas !== undefined && foundAdas !== null) {
              foundAdas.status = 2
              foundAdas.statusName = 'Complete'
            }
          }
        }
      }
    }
  },
  [types.SET_ADASINSPECTIONRESULTS](state, data) {
    state.adasInspectionResults = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasInspectionResults = data
      }
    }
  },
  [types.SET_REPORTPREFERENCE](state, data) {
    state.reportPreference = data
  },
  [types.SET_ADAS_RESET](state, data) {
    state.adasDecodeInfo = data
  },
  [types.SET_LINKS](state, data) {
    state.links = data
    try {
      if (data) {
        if (Array.isArray(data)) {
          data.forEach((element) => {
            if (element.links) {
              if (element.links !== null) {
                try {
                  element.links = JSON.parse(element.links)
                } catch (e) {
                  element.links = []
                }
              }
            }
          })
        } else {
          state.links = data
          if (state.links.links) {
            if (state.links.links !== null) {
              try {
                state.links.links = JSON.parse(state.links.links)
              } catch (e) {
                state.links.links = []
              }
            }
          }
        }
      }
    } catch (e) {
      console.log('Error (adas > mutations > Set Links)', e)
    }
    console.log('Got Links', state.links)
  },
  [types.SET_DECODED](state, data) {
    state.decoded = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/adas/mutations.js